import Header from "PhishingManager/components/Header";
import Step5ReviewStart from "../Step5";
import { useState } from "react";

interface StepProps {
    tenantId: number | string | undefined;
    campaignId: string | number | null;
    onBack: () => void;
    onFinish: () => void;
    showPreview: (id: string | number, languageId: number | null) => void;
    setToast: (
        toast: { message: string; type: 'warning' | 'success' }
    ) => void;
    updateName?: (name: string) => void;
}

const ViewSummary: React.FC<StepProps> = ({
    tenantId,
    campaignId,
    onBack,
    onFinish,
    showPreview,
    setToast
}) => {
    const [campaignName, setCampaignName] = useState<string>("");
    const updateName = (name: string) => {
        setCampaignName(name);
    }
    return (
        <div className="campaign-step-up view-summary">
            <Header title="View setup summary" description={campaignName} onBack={onBack} />
            <div className="step-card-section">
                <Step5ReviewStart {...{ tenantId, campaignId, onBack, onFinish, showPreview, setToast, showSummary: true, updateName }} />
            </div>
        </div>)
}

export default ViewSummary;